import { Box, Group } from "@mantine/core";

import BraouMenu from "./BraouMenu";
import HeaderLogo from "./HeaderLogo";

const BraouHeader: React.FC = () => {
  return (
    <Box
      component="header"
      style={{
        height: "100%",
        width: "100%",
        backdropFilter: "saturate(140%) blur(12px)",
        WebkitBackdropFilter: "saturate(140%) blur(12px)",
        background:
          "light-dark(rgba(255, 255, 255, 0.78), rgba(11, 23, 41, 0.74))",
        borderBottom:
          "1px solid light-dark(var(--mantine-color-gray-2), var(--mantine-color-dark-5))",
      }}
    >
      <Group
        h="100%"
        px={{ base: "md", sm: "xl" }}
        justify="space-between"
        wrap="nowrap"
        maw={1280}
        mx="auto"
      >
        <HeaderLogo />
        <BraouMenu />
      </Group>
    </Box>
  );
};

export default BraouHeader;
